import { observer } from 'mobx-react-lite';
import { Caution } from '@cad-arc';
import { usePriorityColor } from '../../configurable-colors-sounds/use-configured-colors';
import { getPriorityCautionAppearance } from '../../configurable-colors-sounds/priority-colors';

export const PriorityCaution = observer(function PriorityCaution({
    label,
    priorityAttrId,
    agencyTypeGlobalAttrId,
    isPriority1,
}: Readonly<{
    label: string;
    priorityAttrId: number | null | undefined;
    agencyTypeGlobalAttrId: number | null | undefined;
    isPriority1: boolean;
}>) {
    const configuredColor = usePriorityColor(priorityAttrId, agencyTypeGlobalAttrId);
    const { priority, style } = getPriorityCautionAppearance(configuredColor, isPriority1);
    return (
        <Caution priority={priority} size="sm" style={style}>
            {label}
        </Caution>
    );
});
